import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonTitle, IonToolbar, LoadingController, ModalController } from '@ionic/angular/standalone';
import { DisplayService, HideForPlatformDirective, ImageUtil } from '@qid/core';
import { SexyModule } from "@qid/sexy";
import { SuperBackButtonComponent, SuperButtonComponent } from "@qid/super";
import { ImageViewerService } from '../../../../components/image-viewer/image-viewer.service';
import { DocumentAccess, DocumentAccessService } from '../../../document-access';
import { ScannedImage } from '../../../ocr';

@Component({
  selector: 'app-view-multiple-documents',
  templateUrl: './view-multiple-documents.page.html',
  styleUrls: ['./view-multiple-documents.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    HideForPlatformDirective,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    SuperBackButtonComponent
  ]
})
export class ViewMultipleDocumentsPage {

  @Input() document_ids: string[] = [];
  documentAccesses: DocumentAccess[] = [];

  constructor(
    public modalController: ModalController,
    private documentAccessService: DocumentAccessService,
    private displayService: DisplayService,
    private loadingController: LoadingController,
    private imageViewerService: ImageViewerService
  ) {
  }

  ngOnInit() {
    this.loadDocuments();
  }

  downloadAllImages = async () => {
    const loader = await this.loadingController.create({
      message: "Downloading"
    });
    loader.present();

    const downloadPromises = [];
    this.documentAccesses.forEach((item) => {
      item.documentData.scannedImages.forEach((image) => {
        downloadPromises.push(ImageUtil.downloadImage(this.getImage(image.imageUrl)));
      });
    });

    await Promise.all(downloadPromises);

    loader.dismiss();
    this.displayService.toast({
      message: "Images Downloaded"
    });
  };

  async loadDocuments() {

    if (!this.document_ids) {
      return;
    }

    for (let _id of this.document_ids) {
      const access = await this.documentAccessService.findByDocumentId(_id);
      this.documentAccesses.push(access.data[0]);
    }

  }

  getImage(url: string) {
    return ImageUtil.getImageSource(url);
  }
  async viewPhoto(image: ScannedImage) {
    this.imageViewerService.open(image.imageUrl);
  }

  close() {
    this.modalController.dismiss();
  }
}
